<div class="companies-card">
  <div class="peers-companies">
    @for (company of companyFacade.comparableCompanies$ | async; track company) {
      <a [routerLink]="['/', company.ticker]" class="peers-company">
        <span class="ticker">{{ company.ticker }}</span>
        <span class="name">{{ company.name | titlecase }}</span>
      </a>
    }
  </div>

  @if (companyFacade.comparableCompaniesInRequest$ | async) {
    <div class="app-loading-wrapper">
      <app-loading></app-loading>
    </div>
  }
</div>
